import React, { forwardRef } from 'react';

interface UserFullProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const UserFull = forwardRef<HTMLElement, UserFullProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-user ${classes || ''}`} style={style}></i>
  );
});

UserFull.displayName = 'UserFull';